/* eslint-disable */
import React, { useState, Fragment } from "react";
import useUserContext from "../../../hooks/useUserContext";
import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, Label, Tooltip } from "recharts";
import Modal from "../../../components/modal/Modal";
import { MAGIC_NUMBERS } from "../../../constant";
import notify from "../../../services/toast";
import sendCpInvite from "./sendCpInvite";
import CommunityPartnerForm from "../../community_partner/CommunityPartnerForm";

export const Total = ({ marketData, type, dashstats }) => {
	const { userState } = useUserContext();
	const award = dashstats.annualAward;
	const giveAward = dashstats.annualGiveAward;
	const boostAward = dashstats.annualBoostAward;
	const cpAward = dashstats.annualCPAward;
	const navigate = useNavigate();
	const renewal = dashstats.totalRenewals;
	const nonRenewal = dashstats.totalNonRenewals;
	const giveRenewal = dashstats.totalGiveRenewals;
	const giveNonRenewal = dashstats.totalGiveNonRenewals;
	const boostRenewal = dashstats.totalBoostRenewals;
	const boostNonRenewal = dashstats.totalBoostNonRenewals;
	const uniqueApplicants = dashstats?.totalUniqueApplicants || 0;
	const uniqueGiveApplicants = dashstats?.totalUniqueGiveApplicants || 0;
	const uniqueBoostApplicants = dashstats?.totalUniqueBoostApplicants || 0;
	const uniqueCPApplicants = dashstats?.totalUniqueCPApplicants || 0;
	const uniqueApprovedApplicants = dashstats?.totalUniqueApprovedApplicants || 0;
	const uniqueApprovedGiveApplicants = dashstats?.totalUniqueApprovedGiveApplicants || 0;
	const uniqueApprovedBoostApplicants = dashstats?.totalUniqueApprovedBoostApplicants || 0;
	const uniqueApprovedCPApplicants = dashstats?.totalUniqueApprovedCPApplicants || 0;
	const activeBothMemberships = dashstats?.totalActiveBothMemberships || 0;
	const activeGiveMemberships = dashstats?.totalActiveGiveMemberships || 0;
	const activeBoostMemberships = dashstats?.totalActiveBoostMemberships || 0;
	const [inviteCP, setInviteCP] = useState(false);
	const [cpEmail, setCPEmail] = useState("");
	const [showCPForm, setShowCPForm] = useState(false);
	const [isSending, setIsSending] = useState(false);
	//Pie graph
	const data = [
		{ name: "Renewing Scholarships", value: renewal, color: "#56c271" },
		{ name: "New Scholarships", value: nonRenewal, color: "#003057" },
	];

	function CustomLabel({ viewBox, value1, value2 }) {
		const { cx, cy } = viewBox;
		return (
			<svg
				// width="500"
				// height="200"
				className="recharts-text recharts-label"
				textAnchor="middle"
				dominantBaseline="central"
			>
				<text x={cx} y={cy} fill="#3d405c">
					<tspan x={cx} dy="0em" alignmentBaseline="middle" fontSize="14">
						{`${value1} Renewing `}
					</tspan>
					<tspan x={cx} dy="1em" fontSize="14">
						{`${value2} New`}
					</tspan>
				</text>
			</svg>
			//  <text x={cx} y={cy} fill="#3d405c" className="recharts-text recharts-label" textAnchor="middle" dominantBaseline="central">
			//     <tspan alignmentBaseline="middle" fontSize="26">{value1}</tspan>
			//     <tspan fontSize="14">{value2}</tspan>
			//  </text>
		);
	}

	const onSubmit = async (event) => {
		event.preventDefault();
		const emailAddress = { email: cpEmail };
		setIsSending(true);

		try {
			const response = await sendCpInvite(emailAddress); // likely a fetch call
			const data = await response.json(); // extract the actual body

			setIsSending(false);

			if (data.status === "success") {
				notify("Invite sent successfully!", "success");
			} else {
				let displayMessage = "";

				if (Array.isArray(data.message)) {
					displayMessage = data.message[0].message;
				} else {
					displayMessage = data.message;

					if (MAGIC_NUMBERS.SERVER_ERROR_CODES.includes(data.statusCode)) {
						displayMessage =
							"An error has occurred. Please try again later. If this error persists, please contact support.";
					}
				}

				notify(displayMessage, "error");
			}
		} catch (error) {
			setIsSending(false);
			notify("Unable to send Invite. Please try again later.", "error");
		}
	};

	if (!type) {
		return (
			<>
				<section className="grid grid-cols-1 md:grid-cols-5 mt-4 gap-6 mb-8">
					{/* Stats Cards */}
					<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 col-span-5 md:col-span-3">
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-50">
									{dashstats.totalApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total scholarship applications that have been submitted.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Applications</p>
						</div>

						{/* Total Applicants */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-800">
									{uniqueApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										The total number of unique individuals who submitted scholarship applications.
									</div>
								</div>
							</div>
							<p className="text-gray-600">Total Applicants</p>
						</div>

						{/* Approved Applications */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-600">
									{dashstats.totalApprovedApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total scholarship applications that have been reviewed and approved.
									</div>
								</div>
							</div>
							<p className="text-gray-600">Approved Applications</p>
						</div>

						{/* Approved Applicants */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-100">
									{uniqueApprovedApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										The number of unique applicants whose applications were approved.
									</div>
								</div>
							</div>
							<p className="text-gray-600">Total Approved Applicants</p>
						</div>

						{/* Pending Applications */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-yellow-600">
									{dashstats.totalPendingApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Applications that have been submitted but are still waiting for review or decision.
									</div>
								</div>
							</div>
							<p className="text-gray-600">Pending Applications</p>
						</div>

						{/* Active Memberships */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-black">
									{activeBothMemberships}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Total active OfficeRnD memberships associated with the scholarship programs (Boost and Give).
									</div>
								</div>
							</div>
							<p className="text-gray-600">OfficeRnd Active Memberships</p>
						</div>

						{/* Denied Applications */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-danger-500">
									{dashstats.totalDeniedApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>

									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Applications that were reviewed but did not meet the criteria for approval.
									</div>
								</div>
							</div>
							<p className="text-gray-600">Denied Applications</p>
						</div>

					</div>

					{/* Pie Chart */}
					<div className="p-6 bg-white rounded-lg shadow-md flex flex-col items-center col-span-5 md:col-span-2">
						{/* Header on top */}
						<h2 className="text-2xl font-semibold text-gray-800 mb-2 w-full text-center">
							Renewal VS. New Scholarships
						</h2>

						{/* Pie Chart below */}
						<PieChart width={250} height={250}>
							<Pie
								data={data}
								cx="50%"
								cy="50%"
								innerRadius={60}
								outerRadius={100}
								dataKey="value"
							>
								<Label content={<CustomLabel value1={renewal} value2={nonRenewal} />} />
								{data.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={entry.color} />
								))}
							</Pie>
							<Tooltip />
						</PieChart>
					</div>
				</section>

				<div className="inline-block min-w-full py-2 align-middle">
					<div className="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
						<table className="min-w-full divide-y divide-gray-300 text-sm md:text-base">
							<thead className="bg-success-800 text-white">
								<tr>
									<th
										scope="col"
										className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
									>
										City
									</th>
									<th
										scope="col"
										className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
									>
										Total
									</th>
									<th
										scope="col"
										className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
									>
										Pending
									</th>
									<th
										scope="col"
										className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
									>
										Approved
									</th>
									<th
										scope="col"
										className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
									>
										Denied
									</th>
								</tr>
							</thead>

							<tbody className="divide-y divide-gray-200 bg-white">
								{[
									{ city: "Atlanta", total: marketData.totalAtlanta, pending: marketData.totalPendingAtlanta, approved: marketData.totalApprovedAtlanta, denied: marketData.totalDeniedAtlanta },
									{ city: "Central Florida", total: marketData.totalTampa, pending: marketData.totalPendingTampa, approved: marketData.totalApprovedTampa, denied: marketData.totalDeniedTampa },
									{ city: "Charlotte", total: marketData.totalCharlotte, pending: marketData.totalPendingCharlotte, approved: marketData.totalApprovedCharlotte, denied: marketData.totalDeniedCharlotte },
									{ city: "Cincinnati", total: marketData.totalCincinnati, pending: marketData.totalPendingCincinnati, approved: marketData.totalApprovedCincinnati, denied: marketData.totalDeniedCincinnati },
									{ city: "Cleveland", total: marketData.totalCleveland, pending: marketData.totalPendingCleveland, approved: marketData.totalApprovedCleveland, denied: marketData.totalDeniedCleveland },
									{ city: "Columbus", total: marketData.totalColumbus, pending: marketData.totalPendingColumbus, approved: marketData.totalApprovedColumbus, denied: marketData.totalDeniedColumbus },
									{ city: "Indianapolis", total: marketData.totalIndianapolis, pending: marketData.totalPendingIndianapolis, approved: marketData.totalApprovedIndianapolis, denied: marketData.totalDeniedIndianapolis },
									{ city: "Pittsburgh", total: marketData.totalPittsburgh, pending: marketData.totalPendingPittsburgh, approved: marketData.totalApprovedPittsburgh, denied: marketData.totalDeniedPittsburgh },
									{ city: "Springfield", total: marketData.totalSpringfield, pending: marketData.totalPendingSpringfield, approved: marketData.totalApprovedSpringfield, denied: marketData.totalDeniedSpringfield },

								].map((row, index) => (
									<tr
										key={index}
										className="cursor-pointer hover:bg-success-50 transition duration-200 ease-in-out"
										onClick={() => {
											const citySlug = row.city.toLowerCase().replace(" ", "_");
											const route = citySlug === "central_florida" ? "tampa_bay" : citySlug;
											navigate(`/dashboard/locations/${route}`);
										}}
									>
										<td className="whitespace-nowrap py-4 pl-6 font-medium text-gray-900">{row.city}</td>
										<td className="text-md px-6 py-4 text-gray-900">{row.total}</td>
										<td className="text-md px-6 py-4 text-yellow-500">{row.pending}</td>
										<td className="text-md px-6 py-4 text-green-500">{row.approved}</td>
										<td className="text-md px-6 py-4 text-danger-500">{row.denied}</td>
									</tr>

								))}
							</tbody>
						</table>
					</div>
				</div>
			</>
		);
	} else if (type === "give") {
		return (
			<>
				<section className="grid grid-cols-1 md:grid-cols-5 mt-4 gap-6 mb-8">
					{/* Stats Cards */}
					<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 col-span-5 md:col-span-3">
						{/* <div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-800">
								${giveAward?.[0]?.annualAward ? giveAward[0].annualAward.toLocaleString() : 0}
							</h2>
							<p className="text-gray-600">Scholarship Dollars Awarded</p>
						</div> */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-50">
									{dashstats.totalGiveApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total Give scholarship applications that have been submitted.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Applications</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-800">
									{uniqueGiveApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Total number of unique individuals who submitted Give scholarship applications.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Applicants</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-600">
									{dashstats.totalApprovedGiveApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total Give scholarship applications that have been reviewed and approved.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Approved Applications</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-100">
									{uniqueApprovedGiveApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Number of unique applicants whose Give scholarship applications were approved.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Approved Applicants</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-yellow-600">
									{dashstats.totalPendingGiveApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Give scholarship applications that have been submitted and are still waiting for review.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Pending Applications</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-black">
									{activeGiveMemberships}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Total active OfficeRnD memberships associated with the Give scholarship membership.
									</div>
								</div>
							</div>

							<p className="text-gray-600">OfficeRnd Active Give Memberships</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-danger-500">
									{dashstats.totalDeniedGiveApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Give scholarship applications that were reviewed but did not meet approval criteria.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Denied Applications</p>
						</div>

					</div>

					{/* Pie Chart */}
					<div className="p-6 bg-white rounded-lg shadow-md flex flex-col items-center col-span-5 md:col-span-2">
						{/* Header on top */}
						<h2 className="text-2xl font-semibold text-gray-800 mb-2 w-full text-center">
							Renewal VS. New Scholarships
						</h2>

						{/* Pie Chart below */}
						<PieChart width={250} height={250}>
							<Pie
								data={data}
								cx="50%"
								cy="50%"
								innerRadius={60}
								outerRadius={100}
								dataKey="value"
							>
								<Label content={<CustomLabel value1={renewal} value2={nonRenewal} />} />
								{data.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={entry.color} />
								))}
							</Pie>
							<Tooltip />
						</PieChart>
					</div>
				</section>

				<div className="mt-8 flow-root">
					<div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
							<div className="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
								<table className="min-w-full divide-y divide-gray-300 text-sm md:text-base">
									<thead className="bg-success-800 text-white">
										<tr>
											{["City", "Total", "Pending", "Approved", "Denied"].map((heading, i) => (
												<th
													key={i}
													scope="col"
													className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
												>
													{heading}
												</th>
											))}
										</tr>
									</thead>
									<tbody className="divide-y divide-gray-200 bg-white">
										{[
											{ city: "Atlanta", total: marketData.totalGiveAtlanta, pending: marketData.totalGivePendingAtlanta, approved: marketData.totalGiveApprovedAtlanta, denied: marketData.totalGiveDeniedAtlanta },
											{ city: "Central Florida", total: marketData.totalGiveTampa, pending: marketData.totalGivePendingTampa, approved: marketData.totalGiveApprovedTampa, denied: marketData.totalGiveDeniedTampa },
											{ city: "Charlotte", total: marketData.totalGiveCharlotte, pending: marketData.totalGivePendingCharlotte, approved: marketData.totalGiveApprovedCharlotte, denied: marketData.totalGiveDeniedCharlotte },
											{ city: "Cincinnati", total: marketData.totalGiveCincinnati, pending: marketData.totalGivePendingCincinnati, approved: marketData.totalGiveApprovedCincinnati, denied: marketData.totalGiveDeniedCincinnati },
											{ city: "Cleveland", total: marketData.totalGiveCleveland, pending: marketData.totalGivePendingCleveland, approved: marketData.totalGiveApprovedCleveland, denied: marketData.totalGiveDeniedCleveland },
											{ city: "Columbus", total: marketData.totalGiveColumbus, pending: marketData.totalGivePendingColumbus, approved: marketData.totalGiveApprovedColumbus, denied: marketData.totalGiveDeniedColumbus },
											{ city: "Indianapolis", total: marketData.totalGiveIndianapolis, pending: marketData.totalGivePendingIndianapolis, approved: marketData.totalGiveApprovedIndianapolis, denied: marketData.totalGiveDeniedIndianapolis },
											{ city: "Pittsburgh", total: marketData.totalGivePittsburgh, pending: marketData.totalGivePendingPittsburgh, approved: marketData.totalGiveApprovedPittsburgh, denied: marketData.totalGiveDeniedPittsburgh },
											{ city: "Springfield", total: marketData.totalGiveSpringfield, pending: marketData.totalGivePendingSpringfield, approved: marketData.totalGiveApprovedSpringfield, denied: marketData.totalGiveDeniedSpringfield },
										].map((row, index) => {
											const citySlug = row.city.toLowerCase().replace(" ", "_");
											const route = citySlug === "central_florida" ? "tampa_bay" : citySlug;

											return (
												<tr
													key={index}
													className="cursor-pointer hover:bg-success-50 transition duration-200 ease-in-out"
													onClick={() => navigate(`/dashboard/locations/${route}`)}
												>
													<td className="whitespace-nowrap py-4 pl-6 font-medium text-gray-900">{row.city}</td>
													<td className="px-6 py-4 text-gray-900">{row.total}</td>
													<td className="px-6 py-4 text-yellow-500">{row.pending}</td>
													<td className="px-6 py-4 text-green-500">{row.approved}</td>
													<td className="px-6 py-4 text-danger-500">{row.denied}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>

			</>
		);
	} else if (type === "boost") {
		return (
			<>
				<section className="grid grid-cols-1 md:grid-cols-5 mt-4 gap-6 mb-8">
					{/* Stats Cards */}
					<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 col-span-5 md:col-span-3">
						{/* <div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-800">
								${boostAward?.[0]?.annualAward ? boostAward[0].annualAward.toLocaleString() : 0}
							</h2>
							<p className="text-gray-600">Scholarship Dollars Awarded</p>
						</div> */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-50">
									{dashstats.totalBoostApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total Boost scholarship applications that have been submitted.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Applications</p>
						</div>
						
						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-800">
									{uniqueBoostApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Total number of unique individuals who submitted Boost scholarship applications.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Applicants</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-600">
									{dashstats.totalApprovedBoostApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg z-10">
										Total Boost scholarship applications that have been reviewed and approved.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Approved Applications</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-success-100">
									{uniqueApprovedBoostApplicants}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Number of unique applicants whose Boost scholarship applications were approved.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Total Approved Applicants</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-yellow-600">
									{dashstats.totalPendingBoostApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Boost scholarship applications that have been submitted and are waiting to be reviewed.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Pending Applications</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-black">
									{activeBoostMemberships}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Total active OfficeRnD memberships associated with the Boost scholarship membership.
									</div>
								</div>
							</div>

							<p className="text-gray-600">OfficeRnd Active Boost Memberships</p>
						</div>

						<div className="p-4 bg-white rounded-lg shadow-md">
							<div className="flex items-center gap-2">
								<h2 className="text-4xl font-bold text-danger-500">
									{dashstats.totalDeniedBoostApplications}
								</h2>

								<div className="relative group cursor-pointer">
									<span className="text-gray-400 text-sm border rounded-full w-5 h-5 flex items-center justify-center">?</span>
									<div className="absolute left-6 top-0 hidden group-hover:block w-56 bg-gray-800 text-white text-xs rounded p-2 shadow-lg">
										Boost scholarship applications that were reviewed but did not meet the approval criteria.
									</div>
								</div>
							</div>

							<p className="text-gray-600">Denied Applications</p>
						</div>
						
					</div>

					{/* Pie Chart */}
					<div className="p-6 bg-white rounded-lg shadow-md flex flex-col items-center col-span-5 md:col-span-2">
						{/* Header on top */}
						<h2 className="text-2xl font-semibold text-gray-800 mb-2 w-full text-center">
							Renewal VS. New Scholarships
						</h2>

						{/* Pie Chart below */}
						<PieChart width={250} height={250}>
							<Pie
								data={data}
								cx="50%"
								cy="50%"
								innerRadius={60}
								outerRadius={100}
								dataKey="value"
							>
								<Label content={<CustomLabel value1={renewal} value2={nonRenewal} />} />
								{data.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={entry.color} />
								))}
							</Pie>
							<Tooltip />
						</PieChart>
					</div>
				</section>
				<div className="mt-8 flow-root">
					<div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
							<div className="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
								<table className="min-w-full divide-y divide-gray-300 text-sm md:text-base">
									<thead className="bg-success-800 text-white">
										<tr>
											{['City', 'Total', 'Pending', 'Approved', 'Denied'].map((heading, i) => (
												<th
													key={i}
													scope="col"
													className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
												>
													{heading}
												</th>
											))}
										</tr>
									</thead>
									<tbody className="divide-y divide-gray-200 bg-white">
										{[
											{ city: "Atlanta", total: marketData.totalBoostAtlanta, pending: marketData.totalBoostPendingAtlanta, approved: marketData.totalBoostApprovedAtlanta, denied: marketData.totalBoostDeniedAtlanta },
											{ city: "Central Florida", total: marketData.totalBoostTampa, pending: marketData.totalBoostPendingTampa, approved: marketData.totalBoostApprovedTampa, denied: marketData.totalBoostDeniedTampa },
											{ city: "Charlotte", total: marketData.totalBoostCharlotte, pending: marketData.totalBoostPendingCharlotte, approved: marketData.totalBoostApprovedCharlotte, denied: marketData.totalBoostDeniedCharlotte },
											{ city: "Cincinnati", total: marketData.totalBoostCincinnati, pending: marketData.totalBoostPendingCincinnati, approved: marketData.totalBoostApprovedCincinnati, denied: marketData.totalBoostDeniedCincinnati },
											{ city: "Cleveland", total: marketData.totalBoostCleveland, pending: marketData.totalBoostPendingCleveland, approved: marketData.totalBoostApprovedCleveland, denied: marketData.totalBoostDeniedCleveland },
											{ city: "Columbus", total: marketData.totalBoostColumbus, pending: marketData.totalBoostPendingColumbus, approved: marketData.totalBoostApprovedColumbus, denied: marketData.totalBoostDeniedColumbus },
											{ city: "Indianapolis", total: marketData.totalBoostIndianapolis, pending: marketData.totalBoostPendingIndianapolis, approved: marketData.totalBoostApprovedIndianapolis, denied: marketData.totalBoostDeniedIndianapolis },
											{ city: "Pittsburgh", total: marketData.totalBoostPittsburgh, pending: marketData.totalBoostPendingPittsburgh, approved: marketData.totalBoostApprovedPittsburgh, denied: marketData.totalBoostDeniedPittsburgh },
											{ city: "Springfield", total: marketData.totalBoostSpringfield, pending: marketData.totalBoostPendingSpringfield, approved: marketData.totalBoostApprovedSpringfield, denied: marketData.totalBoostDeniedSpringfield },
										].map((row, index) => {
											const citySlug = row.city.toLowerCase().replace(" ", "_");
											const route = citySlug === "central_florida" ? "tampa_bay" : citySlug;

											return (
												<tr
													key={index}
													className="cursor-pointer hover:bg-success-50 transition duration-200 ease-in-out"
													onClick={() => navigate(`/dashboard/locations/${route}`)}
												>
													<td className="whitespace-nowrap py-4 pl-6 font-medium text-gray-900">{row.city}</td>
													<td className="px-6 py-4 text-gray-900">{row.total}</td>
													<td className="px-6 py-4 text-yellow-500">{row.pending}</td>
													<td className="px-6 py-4 text-green-500">{row.approved}</td>
													<td className="px-6 py-4 text-danger-500">{row.denied}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	} else if (type === "Community Partner") {
		return (
			<>
				<div className="grid grid-cols-1 md:grid-cols-6 mt-4 gap-6 mb-8">
					{/* Left Section: Widget Cards */}
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6 col-span-4">
						{/* <div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-800">
								$
								{cpAward?.[0]?.annualAward
									? cpAward[0].annualAward.toLocaleString()
									: 0}
							</h2>
							<p className="text-gray-600">Scholarship Dollars Awarded</p>
						</div> */}
						<div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-600">
								{dashstats.totalApprovedCPApplications}
							</h2>
							<p className="text-gray-600">Approved Applications</p>
						</div>
						<div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-yellow-600">
								{dashstats.totalPendingCPApplications}
							</h2>
							<p className="text-gray-600">Pending Applications</p>
						</div>
						<div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-danger-500">
								{dashstats.totalDeniedCPApplications}
							</h2>
							<p className="text-gray-600">Denied Applications</p>
						</div>
						<div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-800">
								{uniqueCPApplicants}
							</h2>
							<p className="text-gray-600">Total Applicants</p>
						</div>
						<div className="p-4 bg-white rounded-lg shadow-md">
							<h2 className="text-4xl font-bold text-success-800">
								{uniqueApprovedCPApplicants}
							</h2>
							<p className="text-gray-600">Total Approved Applicants</p>
						</div>
					</div>

					{/* Right Section: Add New Community Partner */}
					<div className="p-6 bg-white rounded-lg shadow-md col-span-2 flex justify-center items-center">
						<div className="w-full max-w-md">
							<h2 className="font-bold text-2xl mb-4 text-center">
								Add New Community Partner
							</h2>
							<button
								onClick={() => setInviteCP(true)}
								className="w-full rounded-md bg-success-800 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-success-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-400"
							>
								Actions
							</button>
						</div>
					</div>
				</div>

				<div className="mt-8 flow-root">
					<div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
							<div className="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
								<table className="min-w-full divide-y divide-gray-300 text-sm md:text-base">
									<thead className="bg-success-800 text-white">
										<tr>
											{['City', 'Total', 'Pending', 'Approved', 'Denied'].map((heading, i) => (
												<th
													key={i}
													scope="col"
													className="px-6 py-3 text-left font-semibold uppercase tracking-wider text-xs sm:text-sm md:text-base"
												>
													{heading}
												</th>
											))}
										</tr>
									</thead>
									<tbody className="divide-y divide-gray-200 bg-white">
										{[
											{ city: "Atlanta", total: marketData.totalCPAtlanta, pending: marketData.totalCPPendingAtlanta, approved: marketData.totalCPApprovedAtlanta, denied: marketData.totalCPDeniedAtlanta },
											{ city: "Central Florida", total: marketData.totalCPTampa, pending: marketData.totalCPPendingTampa, approved: marketData.totalCPApprovedTampa, denied: marketData.totalCPDeniedTampa },
											{ city: "Charlotte", total: marketData.totalCPCharlotte, pending: marketData.totalCPPendingCharlotte, approved: marketData.totalCPApprovedCharlotte, denied: marketData.totalCPDeniedCharlotte },
											{ city: "Cincinnati", total: marketData.totalCPCincinnati, pending: marketData.totalCPPendingCincinnati, approved: marketData.totalCPApprovedCincinnati, denied: marketData.totalCPDeniedCincinnati },
											{ city: "Cleveland", total: marketData.totalCPCleveland, pending: marketData.totalCPPendingCleveland, approved: marketData.totalCPApprovedCleveland, denied: marketData.totalCPDeniedCleveland },
											{ city: "Columbus", total: marketData.totalCPColumbus, pending: marketData.totalCPPendingColumbus, approved: marketData.totalCPApprovedColumbus, denied: marketData.totalCPDeniedColumbus },
											{ city: "Indianapolis", total: marketData.totalCPIndianapolis, pending: marketData.totalCPPendingIndianapolis, approved: marketData.totalCPApprovedIndianapolis, denied: marketData.totalCPDeniedIndianapolis },
											{ city: "Pittsburgh", total: marketData.totalCPPittsburgh, pending: marketData.totalCPPendingPittsburgh, approved: marketData.totalCPApprovedPittsburgh, denied: marketData.totalCPDeniedPittsburgh },
											{ city: "Springfield", total: marketData.totalCPSpringfield, pending: marketData.totalCPPendingSpringfield, approved: marketData.totalCPApprovedSpringfield, denied: marketData.totalCPDeniedSpringfield },
										].map((row, index) => {
											const citySlug = row.city.toLowerCase().replace(" ", "_");
											const route = citySlug === "central_florida" ? "tampa_bay" : citySlug;

											return (
												<tr
													key={index}
													className="cursor-pointer hover:bg-success-50 transition duration-200 ease-in-out"
													onClick={() => navigate(`/dashboard/locations/${route}`)}
												>
													<td className="whitespace-nowrap py-4 pl-6 font-medium text-gray-900">{row.city}</td>
													<td className="px-6 py-4 text-gray-900">{row.total}</td>
													<td className="px-6 py-4 text-yellow-500">{row.pending}</td>
													<td className="px-6 py-4 text-green-500">{row.approved}</td>
													<td className="px-6 py-4 text-danger-500">{row.denied}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				{inviteCP && (
					<Modal>
						<div className="fixed z-10 inset-0 overflow-y-auto">
							<div className="flex items-center justify-center min-h-screen p-4">
								<div className="relative inline-block align-bottom bg-white rounded-lg shadow-xl transition-transform transform sm:max-w-xl md:max-w-2xl lg:max-w-3xl w-full p-8 space-y-6">
									{!showCPForm && (
										<>
											<button
												className="absolute top-4 left-4 text-gray-600 hover:text-gray-800 transition duration-300"
												onClick={() => setInviteCP(false)}
											>
												<span className="material-icons-outlined text-2xl">arrow_back_ios</span>
											</button>
											<h1 className="text-2xl font-bold text-center">Invite a Community Partner</h1>
											<p className="text-gray-700 text-center mb-4">
												Please enter the email of the Community Partner you would like to send an invite to.
												After they receive the email, they will be prompted to submit their information.
											</p>
											<form onSubmit={onSubmit} noValidate className="w-full">
												<div className="flex flex-col sm:flex-row gap-4">
													<input
														id="email-address"
														name="email"
														type="email"
														autoComplete="email"
														required
														className="flex-grow rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-primary-400 placeholder:text-gray-400 sm:py-2 sm:px-3"
														placeholder="Enter email"
														onChange={(event) => setCPEmail(event.target.value)}
													/>
													<button
														type="submit"
														className="flex-none rounded-md bg-primary-400 px-4 py-2 text-sm font-semibold text-white shadow-md hover:bg-primary-100 transition duration-300"
														disabled={isSending}
													>
														{isSending ? "Sending..." : "Send"}
													</button>
												</div>
											</form>

											<div className="mt-6 text-center">
												<h2 className="text-lg font-bold">Create Profile</h2>
												<p className="text-gray-600 mb-4">
													Fill in the Community Partner"s details.
												</p>
												<button
													onClick={() => setShowCPForm(true)}
													className="rounded-md bg-primary-400 px-4 py-2 text-sm font-semibold text-white shadow-md hover:bg-primary-100 transition duration-300"
												>
													Community Partner Form{" "}
													<span className="material-icons-outlined text-xs font-bold">arrow_forward_ios</span>
												</button>
											</div>
										</>
									)}
									{showCPForm && (
										<div className="py-6 px-4 sm:px-8 bg-gray-100 rounded-lg shadow-lg">
											{/* Back Button */}
											<div className="mb-4">
												<button
													className="flex items-center text-gray-600 hover:text-gray-800 transition duration-300"
													onClick={() => setShowCPForm(false)}
													aria-label="Go back"
												>
													<span className="material-icons-outlined text-3xl mr-2">arrow_back</span>
													<span className="text-lg font-medium">Go Back</span>
												</button>
											</div>

											{/* Form */}
											<CommunityPartnerForm />
										</div>
									)}
								</div>
							</div>
						</div>
					</Modal>
				)}

			</>
		);
	}
};
